<template>
    <views class="shop-detail">
        <nav-bar
            title="门店详情"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="shop-detail-header">
            <images :src="detail.head_image"></images>
            <views class="shop-detail-header-body">
                <views class="title">{{ detail.name }}</views>
                <views class="tag">
                    <views class="phone">
                        <images :src="phoneIcon"></images>
                        <a :href="tel(detail.contact)" @click.stop>{{ detail.contact }}</a>
                    </views>
                    <views class="addr" @click="handleAddr">
                        <images :src="addrIcon"></images>
                    </views>
                </views>
            </views>
        </views>
        <views class="line"></views>
        <views class="shop-detail-intro">
            <views class="shop-detail-intro-title">门店介绍</views>
            <views class="shop-detail-intro-body" v-html="detail.introduce"></views>
        </views>
        <views class="line"></views>
        <views class="shop-detail-imgs">
            <views class="shop-detail-imgs-title">门店图片</views>
            <views class="shop-detail-imgs-body">
                <images
                    v-for="(item, index) in detail.images"
                    :key="index"
                    :src="item"></images>
            </views>
        </views>
        <views class="line"></views>
        <views class="shop-detail-map">
            <views class="shop-detail-map-title">门店地址</views>
            <views v-show="detail.longitude" class="shop-detail-map-body">
                <el-amap class="amap-box" :vid="'shop-detail'" :center="mapCenter" :zoom="14">
                    <el-amap-marker
                        :position="marker">
                    </el-amap-marker>
                </el-amap>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    data() {
        return {
            detail: {},
            mapCenter: [],
            marker: [],
            phoneIcon: require('@/assets/images/phone_icon.png'),
            addrIcon: require('@/assets/images/detail_addr.png')
        }
    },
    computed: {
        query() {
            return this.$route.query
        }
    },
    created() {
        this.getShopDetail()
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        tel(str) {
            return `tel:${str}`
        },
        // 导航
        handleAddr() {
            const { longitude, latitude, name } = this.detail
            this.windowPush(`/map-navigation?endLng=${longitude}&endLat=${latitude}&toName=${name}`)
        },
        getShopDetail() {
            api.getShopDetail({ id: this.query.id }).then((res) => {
                if (res.data.info) {
                    this.detail = res.data.info
                    // latitude: "39.990633"
                    // longitude: "116.483038"
                    this.mapCenter.push(parseFloat(res.data.info.longitude))
                    this.mapCenter.push(parseFloat(res.data.info.latitude))
                    this.marker.push(parseFloat(res.data.info.longitude))
                    this.marker.push(parseFloat(res.data.info.latitude))
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
